<template>
  <div>
    <Modal v-model="configureCustomizedContentModal" :title="$t('key1000691')" width="1200" :styles="{top: '30px'}" :before-close="handleBeforeClose"
      class-name="configureCustomizedContentStyles" :transfer="false" @on-visible-change="configureCustomizedContentChange">
      <template v-if="configurationType === 'platformOrder'">
        <!--步骤条-->
        <div class="stepBar_box">
          <Steps :current="progressStatus">
            <Step v-for="item in progressList" :title="item.title" icon="md-checkmark-circle"></Step>
          </Steps>
        </div>
        <Divider style="margin: 10px 0 12px 0;"/>
        <template v-if="progressStatus === 0">
          <Button type="primary" :disabled="selectProductTableData.length <=0" ghost @click="batchConfigurationBtn">{{ $t('key1000724') }}</Button>
          <p class="font-size-12 color-666 mt10 mb12">{{ $t('key1001188') }}</p>
        </template>
        <template v-else>
          <Button type="primary" style="margin-bottom: 12px" @click="addCustomizedContentBtn" :disabled="addCustomizedContentTalg">{{ $t('key1000718') }}</Button>
        </template>
      </template>
      <div class="flex align-items-center justify-content-between" v-else>
        <div class="mb14">
          <span>{{ $t('key1001189') }}</span>
          <RadioGroup v-model="isNeedCustomization" style="position: relative; top: -2px;" @on-change="isNeedCustomizationChange">
            <Radio :label="1" style="margin-right: 40px;">{{ $t('key1001190') }}</Radio>
            <Radio :label="0">{{ $t('key1001191') }}</Radio>
          </RadioGroup>
        </div>
        <Button v-if="isNeedCustomization === 1" type="primary" style="margin-bottom: 12px"
          @click="addCustomizedContentBtn" :disabled="addCustomizedContentTalg">{{ $t('key1000718') }}</Button>
      </div>
      <!--选择商品-->
      <template v-if="progressStatus === 0">
        <Table
          ref="tableDom"
          :highlight-row="false"
          border
          max-height="530"
          :loading="tableLoading"
          :columns="selectProductColumns"
          @on-selection-change="getSelectValue"
          :data="selectProductTableData">
          <!--是否需要定制-->
          <template #isNeedCustomization="{row, index}">
            <Select v-model.trim="selectProductTableData[index].isNeedCustomization" style="width:140px;">
              <Option v-for="(k, index) in customizedTypeList" :key="index" :value="k.value">{{ k.name }}</Option>
            </Select>
          </template>
        </Table>
      </template>
      <!--配置定制内容-->
      <template v-if="(progressStatus === 1 && configurationType === 'platformOrder') ||
     configurationType !== 'platformOrder' && isNeedCustomization === 1">
        <Table
          :disabled-hover="true"
          :highlight-row="false"
          border
          max-height="530"
          :loading="tableLoading"
          :columns="customizedContentColumns"
          :data="customizedContentTableData">
          <!--定制部位-->
          <template #customizedParts="{row, index}">
            <Select v-model.trim="customizedContentTableData[index].customizedParts" style="width:150px;" filterable transfer
              @on-change="(value)=>customizedPartsChange(value)">
              <Option v-for="(k, index) in customizedPartsList" :disabled="k.disabled" :key="index" :value="k.ymsProductCategoryPositionId">{{ k.parts }}</Option>
            </Select>
          </template>
          <!--素材图-->
          <template #materialImage="{row, index}">
            <span v-if="!customizedContentTableData[index].customizedParts" class="font-size-12 color-666">{{ $t('key1000719') }}</span>
            <template v-else>
              <div class="imgagesList_box" v-viewer="viewerOptions" v-if="customizedContentTableData[index].materialImageList">
                <div class="imgagesList_box_item" v-for="(path,idx) in customizedContentTableData[index].materialImageList" :key="idx">
                  <div class="img_content">
                    <span class="clickOnCrop_box">{{ $t('key1000720') }}</span>
                    <img class="img-styles" :src="setImgPath(path, null, null, null, false)" @error="setErrorImg($event)" alt=""/>
                  </div>
                  <div class="flex align-items-center justify-content-center cursor mt8">
                    <span class="font-size-12 themeColor mr4" style="position: relative; top: 1px;" @click="deleteImgBtn(index,idx, 'materialImage')">{{ $t('key1000512') }}</span>
                    <Icon type="ios-trash-outline" size="18" @click="deleteImgBtn(index,idx, 'materialImage')"/>
                  </div>
                </div>
                <Upload
                  v-if="customizedContentTableData[index].materialImageList.length < 1"
                  name="files"
                  :headers="headObj"
                  :show-upload-list="false"
                  :on-success="(response, file, fileList) => uploadImageSuccess(response, file, fileList, index, 'materialImage')"
                  :on-error="uploadFilesError"
                  :before-upload="(file) => handleImgbeforeUpload(file)"
                  :multiple="false"
                  :action="uploadFilesUrl"
                  type="drag"
                  style="display: inline-block; width:75px;">
                  <div class="upload-box">
                    <i class="iconfont upload-icon">&#xe63e;</i>
                    <p>{{ $t('key1000465') }}</p>
                  </div>
                </Upload>
                <span class="distributorThemeColor cursor font-size-13 select_customized"
                  v-if="imgList.length >0 && customizedContentTableData[index].materialImageList.length < 1"
                  @click="$refs['platformCustomizedMaterials'].initPlatformCustomizedMaterialsData('materialImage',index)">
                  {{ $t('key1001192') }}
                </span>
              </div>
            </template>
          </template>
          <!--成品预览图-->
          <template #finishedProductPreviewImage="{row, index}">
            <span v-if="!customizedContentTableData[index].customizedParts" class="font-size-12 color-666">{{ $t('key1000719') }}</span>
            <template v-else>
              <div class="imgagesList_box" v-viewer="viewerOptions" v-if="customizedContentTableData[index].finishedProductPreviewImageList">
                <div class="imgagesList_box_item" v-for="(path,idx) in customizedContentTableData[index].finishedProductPreviewImageList" :key="idx">
                  <div class="img_content">
                    <span class="clickOnCrop_box">{{ $t('key1000720') }}</span>
                    <img class="img-styles" :src="setImgPath(path, null, null, null, false)" @error="setErrorImg($event)" alt=""/>
                  </div>
                  <div class="flex align-items-center justify-content-center cursor mt8">
                    <span class="font-size-12 themeColor mr4" style="position: relative; top: 1px;" @click="deleteImgBtn(index,idx, 'finishedProductPreviewImage')">{{ $t('key1000512') }}</span>
                    <Icon type="ios-trash-outline" size="18" @click="deleteImgBtn(index,idx, 'finishedProductPreviewImage')"/>
                  </div>
                </div>
                <Upload
                  v-if="customizedContentTableData[index].finishedProductPreviewImageList.length < 2"
                  name="files"
                  :headers="headObj"
                  :show-upload-list="false"
                  :on-success="(response, file, fileList) => uploadImageSuccess(response, file, fileList, index, 'finishedProductPreviewImage')"
                  :on-error="uploadFilesError"
                  :before-upload="(file) => handleImgbeforeUpload(file)"
                  multiple
                  :action="uploadFilesUrl"
                  type="drag"
                  style="display: inline-block; width:75px;">
                  <div class="upload-box">
                    <i class="iconfont upload-icon">&#xe63e;</i>
                    <p>{{ $t('key1000465') }}</p>
                  </div>
                </Upload>
                <span class="distributorThemeColor cursor font-size-13 select_customized"
                  v-if="imgList.length >0 && customizedContentTableData[index].finishedProductPreviewImageList.length < 2"
                  @click="$refs['platformCustomizedMaterials'].initPlatformCustomizedMaterialsData('finishedProductPreviewImage', index)">
                  {{ $t('key1001192') }}
                </span>
              </div>
            </template>
          </template>
        </Table>
      </template>
      <template #footer>
        <Button @click="cancelBtn">{{ $t('key1000112') }}</Button>
        <Button v-if="progressStatus >0 && configurationType === 'platformOrder'" @click="previousStepBtn">{{ $t('key1000725') }}</Button>
        <Button type="primary" @click="saveAndConfirmBtn">{{ saveAndConfirmText }}</Button>
      </template>
    </Modal>
    <!--平台定制数据选择弹窗-->
    <platformCustomizedMaterialsModal
      :imgList="imgList"
      ref="platformCustomizedMaterials"
      @updateImgData="updateImgData"
    ></platformCustomizedMaterialsModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import platformCustomizedMaterialsModal from "@/views/distributor/components/orderManage/platformCustomizedMaterialsModal.vue";
import api from '@/api/';
import {isJSON} from "@/utils/common";

export default {
  name: 'configureCustomizedContentModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      uploadFilesUrl: api.erpCommon_uploadFiles + '?basePath=yms-distributor-service&action="uploadimage"',
      progressStatus: 0,
      progressList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001182')},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001183')}
      ],
      configureCustomizedContentModal: false,
      selectProductColumns: [
        {
          type: 'selection',
          width: 60,
          key: 'select',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          minWidth: 320,
          key: 'productInfo',
          align: 'left',
          render(h, params) {
            let ymsSpu = params.row.ymsSpu;
            let productName = params.row.productName;
            let imgPath = params.row.imgPath;
            let list = [
              v.tableImg(h, params, 'primaryImage', imgPath),
              h('div', {
                class: 'text-align-left pl10'
              }, [
                h('Alink', {
                  props: {
                    AlinkShow: false,
                    linkName: productName,
                    textAlign: 'left',
                    className: 'mb5',
                    AlinkClass: 'ellipsis_2'
                  }
                }),
                h('p', {class: 'flex align-items-center'}, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000689')),
                  h('Alink', {
                    props: {
                      AlinkShow: false,
                      linkName: ymsSpu,
                      textAlign: 'left',
                      AlinkClass: 'distributorThemeColor'
                    }
                  })
                ]),
              ])
            ];
            return h('div', {
              class: 'flex ptb10',
            }, list);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000239'),
          minWidth: 170,
          key: 'skuInfo',
          align: 'left',
          render: (h, params) => {
            let ymsSku = params.row.ymsSku;
            let specifications = params.row.specifications;
            return h('div', [
              h('p', {class: 'mt2 mb2'}, ymsSku),
              h('p', {class: 'mt2 mb2 color-green'}, specifications)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001184'),
          key: 'isNeedCustomization',
          minWidth: 160,
          align: 'left',
          slot: 'isNeedCustomization'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'center',
          minWidth: 150,
          render(h, params) {
            let isNeedCustomization = params.row.isNeedCustomization;
            let configureCustomizedInfo = params.row.configureCustomizedInfo;
            return h('div', {class: 'flex align-items-center justify-content-center'}, [
              isNeedCustomization === 1 && Object.keys(configureCustomizedInfo).length > 0 ? h('Icon', {
                props: {
                  type: 'ios-checkmark-circle-outline',
                  size: 20,
                  color: '#0FE316'
                },
                class: 'mr8'
              }) : '',
              isNeedCustomization === 1 && Object.keys(configureCustomizedInfo).length <= 0 ? h('Icon', {
                props: {
                  type: 'ios-alert-outline',
                  size: 20,
                  color: '#FF9B06'
                },
                class: 'mr8'
              }) : '',
              isNeedCustomization === 1 ? h('span', {
                class: 'cursor themeColor',
                on: {
                  click() {
                    v.configureCustomizedContentData('single', params.row, params.index);
                  }
                }
              }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000691')) : '',
              isNeedCustomization === 0 ? h('span', {
                class: 'color-666',
              }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001185')) : ''
            ]);
          }
        }
      ],
      selectProductTableData: [],
      selectGoodsList: [],
      customizedTypeList: [
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000392')},
        {value: 0, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000393')},
      ],
      customizedContentColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000692'),
          key: 'customizedParts',
          minWidth: 150,
          align: 'left',
          renderHeader: (h, params) => {
            return h('span', {class: 'required'}, params.column.title);
          },
          slot: 'customizedParts'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000693'),
          key: 'materialImage',
          minWidth: 300,
          align: 'left',
          renderHeader: (h, params) => {
            return h('span', {class: 'required'}, params.column.title);
          },
          slot: 'materialImage'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000694'),
          renderHeader: (h, params) => {
            return h('span', {class: 'required'}, params.column.title);
          },
          key: 'finishedProductPreviewImage',
          minWidth: 300,
          align: 'left',
          slot: 'finishedProductPreviewImage'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'center',
          width: 100,
          render(h, params) {
            return h('optsButtonList', {
              props: {
                isShowMoreBtn: false,
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    show: v.customizedContentTableData.length > 1,
                    clickFn: () => {
                      v.deleteCustomizedContentBtn(params.index);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      customizedContentTableData: [],
      customizedPartsList: [],
      optionsType: null,
      currentIndex: null,
      configurationType: null,
      isNeedCustomization: 1,
      detailsData: {},
      ymsPlatformOrderId: null,
      imgList: [],
      itSNotACustomizedProductList: [],
    };
  },
  computed: {
    saveAndConfirmText() {
      return this.progressStatus === 0 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000111') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000555');
    },
    addCustomizedContentTalg() {
      return this.customizedPartsList.every(item => item.disabled === true) ||
        this.customizedContentTableData.length >= this.customizedPartsList.length;
    },
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
  },
  methods: {
    // 初始化数据
    initConfigureCustomizedContentData(type, obj, currentIndex) {
      this.configurationType = type; // 平台订单：platformOrder、调整订单：adjustOrder、创建手工单：createAHandmadeOrder
      this.customizedPartsList = [];
      // 创建手工单、调整订单---配置定制内容
      if (type !== 'platformOrder') {
        if (obj) {
          this.detailsData = obj;
          this.currentIndex = currentIndex;
          let ymsProductGoodsPositions = obj.ymsProductGoodsPositions || [];
          ymsProductGoodsPositions.map((item) => {
            item.disabled = false;
          });
          this.customizedPartsList = ymsProductGoodsPositions; // 选择部位的基础数据
          // 定制配置信息
          if (Object.keys(obj.configureCustomizedInfo).length > 0) {
            let newList = [];
            this.isNeedCustomization = obj.configureCustomizedInfo.isNeedCustomization;
            if (obj.configureCustomizedInfo.isNeedCustomization === 1) {
              let partBosList = obj.configureCustomizedInfo.partBos;
              partBosList.map((item) => {
                let materialImageList = item.imageBos.filter(ele => ele.imageType === 1);
                let finishedProductPreviewImageList = item.imageBos.filter(ele => ele.imageType === 2);
                newList.push({
                  customizedParts: ymsProductGoodsPositions.filter((ele) => ele.parts === item.parts)[0].ymsProductCategoryPositionId,
                  materialImageList: materialImageList.map(ele => ele.path),
                  finishedProductPreviewImageList: finishedProductPreviewImageList.map(ele => ele.path)
                });
              });
              this.customizedContentTableData = newList;
            } else {
              this.customizedContentTableData = [];
            }
          } else {
            this.addCustomizedContentBtn();
          }
          this.customizedPartsList.forEach(item => {
            item.disabled = false;
            this.customizedContentTableData.map((ele) => {
              if (item.ymsProductCategoryPositionId === ele.customizedParts) {
                item.disabled = true;
              }
            });
          });
        }
        this.progressStatus = 1;
      }
      // 平台订单--配置定制内容
      else {
        let ymsPlatformOrderTransactionsList = [];
        let {ymsPlatformOrderId, ymsPlatformOrderTransactions = []} = obj;
        this.ymsPlatformOrderId = ymsPlatformOrderId;
        if (ymsPlatformOrderTransactions.length > 0) {
          ymsPlatformOrderTransactions.map((item, index) => {
            const quantity = item.quantity || 1;
            const ymsProductGoodsId = item.businessId;
            for (let i = 0; i < quantity; i++) {
              const newItem = JSON.parse(JSON.stringify(item));
              newItem.newQuantity = 1;
              newItem.ymsProductGoodsId = ymsProductGoodsId;
              newItem.customizedConfigId = ymsProductGoodsId + '_' + item.ymsSku + '_' + index + '_' + i;
              ymsPlatformOrderTransactionsList.push(newItem);
            }
          });
          if (ymsPlatformOrderTransactionsList.length > 0) {
            const ymsProductGoodsIds = ymsPlatformOrderTransactionsList.map(item => item.ymsProductGoodsId).filter(id => id);
            (async () => {
              let newList = await this.getProductInfoByIds(ymsProductGoodsIds, ymsPlatformOrderTransactionsList);
              newList.map((item) => {
                item.isNeedCustomization = 1;
                if (!item.configureCustomizedInfo) {
                  item.configureCustomizedInfo = {};
                }
                let specificationsList = [];
                if (item._productInfo) {
                  let skuImgPath = item._productInfo.primaryImage;
                  let spuImgPath = item._productInfo._spuInfo.primaryImage;
                  item.imgPath = skuImgPath ? skuImgPath : spuImgPath;
                  item.productName = item._productInfo._spuInfo.name;
                  item.ymsSpu = item._productInfo._spuInfo.ymsSpu;
                  item.isSupportCustomization = item._productInfo._spuInfo.isSupportCustomization || 0; // 商品定制   1是  0否
                  item.ymsProductGoodsPositions = item._productInfo.ymsProductGoodsPositions || []; // 商品定制部位下拉数据
                  let productGoodsSpecifications = item._productInfo.productGoodsSpecificationList || [];
                  if (productGoodsSpecifications.length > 0) {
                    specificationsList = productGoodsSpecifications.map((item) => {
                      return item.value;
                    });
                  }
                  item.isCustomization = item._productInfo.isCustomization || 0;
                  item.specifications = specificationsList.join(' • ');
                }
                // 处理平台素材信息
                item.imageList = [];
                // 成品图 2
                let customInfo = item.customInfo;
                if (customInfo) {
                  if (isJSON(customInfo)) {
                    let vals = JSON.parse(customInfo);
                    let list = vals.preview.effects || [];
                    list.map((k) => {
                      item.imageList.push({
                        imageType: 2,
                        path: k
                      });
                    });
                  }
                }
                // 素材图 1
                let resourcesUrl = item.resourcesUrl;
                if (resourcesUrl) {
                  if (isJSON(resourcesUrl)) {
                    let list = JSON.parse(resourcesUrl) || [];
                    list.map((k) => {
                      item.imageList.push({
                        imageType: 1,
                        path: k
                      });
                    });
                  }
                }
                if (item.isSupportCustomization !== 1) {
                  item.isNeedCustomization = 0;
                }
              });
              let newData = newList.filter((item) => item.isSupportCustomization === 1 && !item._productInfo.originalYmsProductGoodsId);
              this.itSNotACustomizedProductList = newList.filter((item) => item.isSupportCustomization !== 1);
              this.selectProductTableData = newData;
            })();
          }
        }
        this.progressStatus = 0;
      }
      this.configureCustomizedContentModal = true;
    },
    // 勾选列表数据
    getSelectValue(data) {
      this.selectGoodsList = data;
    },
    // 批量配置
    batchConfigurationBtn() {
      if (this.selectGoodsList.length > 0) {
        let talg = this.selectGoodsList.every((item) => item.isNeedCustomization === 1);
        if (talg) {
          this.configureCustomizedContentData('all');
        } else {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001186'));
          return false;
        }
      } else {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000709'));
        return false;
      }
    },
    // 添加定制部位
    addCustomizedContentBtn() {
      this.customizedContentTableData.push({
        customizedParts: null,
        materialImageList: [],
        finishedProductPreviewImageList: []
      });
    },
    // 删除定制部位
    deleteCustomizedContentBtn(index) {
      this.customizedContentTableData.splice(index, 1);
      this.customizedPartsList.forEach(item => {
        item.disabled = false;
        this.customizedContentTableData.map((ele) => {
          if (item.ymsProductCategoryPositionId === ele.customizedParts) {
            item.disabled = true;
          }
        });
      });
      this.$forceUpdate();
    },
    // 处理配置定制内容
    configureCustomizedContentData(type, obj, index) {
      this.imgList = [];
      this.optionsType = type;
      this.currentIndex = index;
      if (type === 'single') {
        let {ymsProductGoodsPositions, configureCustomizedInfo, isNeedCustomization} = obj;
        this.customizedPartsList = JSON.parse(JSON.stringify(ymsProductGoodsPositions));
        this.selectGoodsList = [obj];
        // 已配置定制内容
        let newList = [];
        if (Object.keys(configureCustomizedInfo).length > 0) {
          if (isNeedCustomization === 1) {
            let partBosList = configureCustomizedInfo.partBos;
            partBosList.map((item) => {
              let materialImageList = item.imageBos.filter(ele => ele.imageType === 1);
              let finishedProductPreviewImageList = item.imageBos.filter(ele => ele.imageType === 2);
              newList.push({
                customizedParts: ymsProductGoodsPositions.filter((ele) => ele.parts === item.parts)[0].ymsProductCategoryPositionId,
                materialImageList: materialImageList.map(ele => ele.path),
                finishedProductPreviewImageList: finishedProductPreviewImageList.map(ele => ele.path)
              });
            });
            this.customizedContentTableData = newList;
            this.customizedPartsList.forEach(item => {
              item.disabled = false;
              this.customizedContentTableData.map((ele) => {
                if (item.ymsProductCategoryPositionId === ele.customizedParts) {
                  item.disabled = true;
                }
              });
            });
          }
        }
        // 未配置定制内容
        else {
          this.addCustomizedContentBtn();
        }
        this.imgList = obj.imageList;
      }
      // 批量配置定制内容
      else {
        const newList = [];
        if (this.selectGoodsList.length > 1) {
          const idCount = this.selectGoodsList.reduce((acc, item) => {
            (item.ymsProductGoodsPositions || []).forEach(pos => {
              acc[pos.ymsProductCategoryPositionId] = (acc[pos.ymsProductCategoryPositionId] || 0) + 1;
            });
            return acc;
          }, {});
          const duplicatedIds = new Set(Object.keys(idCount).filter(id => idCount[id] > 1));
          const added = new Set();
          this.selectGoodsList.forEach(item => {
            this.imgList.push(...item.imageList);
            (item.ymsProductGoodsPositions || []).forEach(pos => {
              if (duplicatedIds.has(pos.ymsProductCategoryPositionId)) {
                const key = `${pos.ymsProductCategoryPositionId}_${pos.parts}`;
                if (!added.has(key)) {
                  newList.push({...pos});
                  added.add(key);
                }
              }
            });
          });
          newList.forEach(item => {
            item.disabled = false;
          });
        } else {
          this.selectGoodsList.forEach(item => {
            (item.ymsProductGoodsPositions || []).forEach(pos => {
              newList.push({...pos, disabled: false});
            });
          });
        }
        this.customizedPartsList = this.uniqueFunc(newList, 'ymsProductCategoryPositionId');
        this.addCustomizedContentBtn();
      }
      this.progressStatus = 1;
    },
    // 取消按钮
    cancelBtn() {
      this.handleBeforeClose().then(() => {
        this.selectGoodsList = [];
        this.configureCustomizedContentModal = false;
      });
    },
    // 上一步
    previousStepBtn() {
      this.handleBeforeClose().then(() => {
        this.progressStatus = 0;
        this.configurationType = 'platformOrder';
        this.selectGoodsList = [];
      });
    },
    // 保存、确定按钮
    saveAndConfirmBtn() {
      let v = this;
      switch (v.progressStatus) {
        // 确定
        case 0:
          if (v.selectProductTableData.length > 0) {
            // 校验定制商品信息
            let customizedProductInfoTalg = true;
            let customizedProductInfoList = v.selectProductTableData.filter((item) => item.isNeedCustomization === 1);
            if (customizedProductInfoList.length > 0) {
              customizedProductInfoTalg = customizedProductInfoList.every((item) => Object.keys(item.configureCustomizedInfo).length > 0);
            }
            if (!customizedProductInfoTalg) {
              v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000704'));
              return false;
            }
            let saveCustomizedGoodsDetailBosList = [];
            let tableData = [...v.selectProductTableData, ...v.itSNotACustomizedProductList];
            tableData.map((item) => {
              let obj = {};
              let newList = [];
              let partBos = [];
              let {configureCustomizedInfo, isNeedCustomization} = item;
              let {ymsProductGoods, ymsProductGoodsId, ymsSku} = configureCustomizedInfo;
              if (isNeedCustomization === 1) {
                let ymsProductGoodsSpecificationsList = ymsProductGoods.ymsProductGoodsSpecifications || [];
                ymsProductGoodsSpecificationsList.map((k) => {
                  let ymsProductGoodsSpecificationImagesList = k.ymsProductGoodsSpecificationImages || [];
                  ymsProductGoodsSpecificationImagesList.map((j) => {
                    newList.push(j);
                  });
                });
                let newData = v.handerGrouping(newList, function (item) {
                  return [item.parts];
                }, 'parts', 'data');
                newData.map((talg) => {
                  let data = talg.data.map((p, idx) => {
                    return {
                      md5: p.md5,
                      path: p.path,
                      sortNo: idx,
                      imageType: p.imageType
                    };
                  });
                  partBos.push({
                    parts: talg.parts,
                    imageBos: data
                  });
                });
                obj = {
                  businessId: ymsProductGoods.ymsProductGoodsId,
                  isNeedCustomization: 1,
                  originalBusinessId: ymsProductGoodsId,
                  originalYmsSku: ymsSku,
                  partBos: partBos,
                  quantity: item.newQuantity,
                  ymsPlatformOrderTransactionId: item.ymsPlatformOrderTransactionId,
                  ymsSku: ymsProductGoods.ymsSku,
                };
              } else {
                obj = {
                  businessId: item.ymsProductGoodsId,
                  isNeedCustomization: 0,
                  quantity: item.newQuantity,
                  ymsPlatformOrderTransactionId: item.ymsPlatformOrderTransactionId,
                  ymsSku: item.ymsSku
                };
              }
              saveCustomizedGoodsDetailBosList.push(obj);
            });
            let arr = Object.values(saveCustomizedGoodsDetailBosList.reduce((acc, item) => {
              const key = `${item.businessId}-${item.isNeedCustomization}`;
              if (!acc[key]) {
                acc[key] = {...item};
              } else {
                acc[key].quantity += item.quantity;
              }
              return acc;
            }, {}));
            let query = {
              saveCustomizedGoodsDetailBos: arr,
              ymsPlatformOrderId: v.ymsPlatformOrderId
            };
            v.axios.post(api.post_ymsPlatformOrder_saveCustomizedGoods, query,
              {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.configureCustomizedContentModal = false;
                v.$emit('updateData', true);
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000708'));
              }
            });
          }
          break;
        // 保存
        case 1:
          const fieldList = [
            {key: 'customizedParts', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000692')},
            {key: 'materialImageList', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000693')},
            {key: 'finishedProductPreviewImageList', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000694')}
          ];
          if (v.isNeedCustomization === 1 || v.configurationType === 'platformOrder') {
            for (let i = 0; i < v.customizedContentTableData.length; i++) {
              const item = v.customizedContentTableData[i];
              for (const field of fieldList) {
                const value = item[field.key];
                if ((field.key !== 'customizedParts' && (!value || value.length === 0)) || (field.key === 'customizedParts' && !value)) {
                  v.$Message.error(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000679')}${i + 1}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000680')}${field.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000681')}`);
                  return;
                }
              }
            }
          }
          if (v.configurationType === 'platformOrder') {
            // 更新配置定制信息
            v.obtainCustomizedProductData(v.customizedContentTableData).then((newList) => {
              v.selectProductTableData.map((item) => {
                newList.map((ele) => {
                  if (item.customizedConfigId === ele.customizedConfigId) {
                    item.configureCustomizedInfo = ele;
                  }
                });
              });
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000705'));
              setTimeout(() => {
                v.customizedContentTableData = [];
                v.customizedPartsList = [];
                v.selectGoodsList = [];
                v.progressStatus = 0;
              }, 500);
            });
          } else {
            if (v.isNeedCustomization === 1) {
              v.obtainCustomizedProductData(v.customizedContentTableData).then((newList) => {
                let obj = {};
                if (newList.length > 0) {
                  newList.forEach(item => {
                    if (item.ymsProductGoodsId === v.detailsData.ymsProductGoodsId) {
                      obj = item;
                    }
                  });
                  let vals = {
                    ...obj,
                    currentIndex: v.currentIndex,
                    isNeedCustomization: 1
                  };
                  v.$emit('updateCustomInfoData', vals);
                  v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000705'));
                  v.configureCustomizedContentModal = false;
                }
              });
            } else {
              let vals = {
                currentIndex: v.currentIndex,
                isNeedCustomization: 0
              };
              v.$emit('updateCustomInfoData', vals);
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000705'));
              v.configureCustomizedContentModal = false;
            }
          }

          break;
      }
    },
    // 获取定制商品数据
    obtainCustomizedProductData(data) {
      let v = this;
      return new Promise((resolve) => {
        let list = [];
        if (data.length > 0) {
          let partBos = [];
          const handleImgList = (imgData, type) => {
            let newList = imgData.map((k) => {
              return {
                path: v.setImgPath(k, 'distributor', null, null, false),
                imageType: type
              };
            });
            return newList;
          };
          data.map((item) => {
            let parts = v.customizedPartsList.filter(ele => ele.ymsProductCategoryPositionId === item.customizedParts)[0].parts;
            let finishedProductPreviewImageList = item.finishedProductPreviewImageList || [];
            let materialImageList = item.materialImageList || [];
            partBos.push({
              parts,
              imageBos: [
                ...handleImgList(materialImageList, 1),
                ...handleImgList(finishedProductPreviewImageList, 2)
              ]
            });
          });
          if (v.configurationType === 'platformOrder') {
            v.selectGoodsList.map((item) => {
              list.push({
                partBos,
                ymsProductGoodsId: item.ymsProductGoodsId,
                ymsSku: item.ymsSku,
                customizedConfigId: item.customizedConfigId,
                customizedType: 2, // 下单定制
                vestMerchantId: v.userInfo.merchantId,
              });
            });
          } else {
            list = [{
              partBos,
              ymsProductGoodsId: v.detailsData.ymsProductGoodsId,
              ymsSku: v.detailsData.ymsSku,
              customizedType: 2, // 下单定制
              vestMerchantId: v.userInfo.merchantId,
            }];
          }
          v.axios.post(api.post_ymsProductGoods_api_queryCustomizationGoods, list,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001187')}).then(response => {
            if (response.data.code === 0) {
              let newData = response.data.datas || [];
              resolve(newData);
            }
          });
        }
      });
    },
    // 更新上传图片
    updateImgData(obj) {
      let {currentIndex, imgList, optionsType} = obj;
      let name = optionsType === 'materialImage' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000693') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000694');
      this.customizedContentTableData[currentIndex][optionsType + 'List'].push(...imgList);
      this.customizedContentTableData[currentIndex][optionsType + 'List'] = this.customizedContentTableData[currentIndex][optionsType + 'List'].slice(0, 2);
      this.$Message.success(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000682')}${name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000683')}`);
      this.$forceUpdate();
    },
    // 上传图片之前的校验
    handleImgbeforeUpload(file, type) {
      const maxSize = 5;
      return new Promise((resolve, reject) => {
        const isJPG = ['image/png', 'image/jpeg', 'image/jpg'].includes(file.type);
        const isLtMax = file.size / 1024 / 1024 <= maxSize;

        if (!isJPG) {
          this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000710'));
          reject();
        }
        if (!isLtMax) {
          this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000711'));
          reject();
        }
        resolve();
      });
    },
    // 上传图片成功
    uploadImageSuccess(response, file, fileList, index, type) {
      let name = type === 'materialImage' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000693') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000694');
      if (response.code === 0 && response.datas) {
        let url = response.datas[0];
        if (url) {
          this.customizedContentTableData[index][type + 'List'].push(url);
          let length = 2;
          if (type === 'materialImage') {
            length = 1;
          }
          this.customizedContentTableData[index][type + 'List'] = this.customizedContentTableData[index][type + 'List'].slice(0, length);
        }
        this.$Message.success(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000682')}${name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000683')}`);
      } else {
        this.$Message.error(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000682')}${name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000684')}`);
      }
    },
    // 删除图片
    deleteImgBtn(index, imgIndex, type) {
      this.customizedContentTableData[index][type + 'List'].splice(imgIndex, 1);
      this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000712'));
      this.$forceUpdate();
    },
    // 选择定制部位
    customizedPartsChange(value) {
      this.customizedPartsList.forEach(item => {
        item.disabled = false;
        this.customizedContentTableData.map((ele) => {
          if (item.ymsProductCategoryPositionId === ele.customizedParts) {
            item.disabled = true;
          }
        });
      });
    },
    // 监听弹窗
    configureCustomizedContentChange(value) {
      if (!value) {
        this.ymsPlatformOrderId = null;
        this.selectProductTableData = [];
        this.detailsData = {};
        this.progressStatus = 0;
        this.selectGoodsList = [];
        this.customizedContentTableData = [];
        this.currentIndex = null;
        this.isNeedCustomization = 1;
        this.itSNotACustomizedProductList = [];
      }
    },
    // 关闭之前的二次弹窗提示确认
    handleBeforeClose(value) {
      let v = this;
      return new Promise((resolve, reject) => {
        v.$Modal.confirm({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000701'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000702'),
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000111'),
          cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
          onOk: () => {
            v.resetData();
            if (value !== 'back') {
              resolve();
            } else {
              reject();
            }
          },
          onCancel: () => {
            reject();
          }
        });
      });
    },
    // 重置数据
    resetData() {
      this.optionsType = null;
      this.currentIndex = null;
      this.configurationType = null;
      this.isNeedCustomization = 1;
      this.customizedContentTableData = [];
    },
    // 切换定制类型
    isNeedCustomizationChange(value) {
      if (value === 1) {
        if (this.customizedContentTableData.length <= 0) {
          this.addCustomizedContentBtn();
        }
      }
    }
  },
  components: {
    platformCustomizedMaterialsModal
  }
};
</script>

<style lang="less" scoped>
/deep/ .configureCustomizedContentStyles {
  .stepBar_box {
    padding: 10px 100px;
    background-color: #fff;

    .ivu-steps {
      .ivu-steps-item {
        overflow: initial;
      }

      .ivu-steps-main {
        display: flex;
        flex-direction: column;
      }

      .ivu-steps-head {
        display: table-cell;
        padding-left: 0;
      }

      .ivu-steps-tail {
        left: 7px;
      }

      .ivu-steps-content {
        padding: 0;
      }
    }
  }

  .imgagesList_box {
    margin: 8px 0;
    display: flex;
    flex-wrap: wrap;
    position: relative;

    .imgagesList_box_item {
      margin: 0 8px 0 0;

      .img_content {
        position: relative;
        cursor: pointer;
        width: 75px;
        height: 75px;

        .clickOnCrop_box {
          width: 100%;
          height: 20px;
          line-height: 20px;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 10;
          text-align: center;
          font-size: 12px;
          color: #fff;
          background-color: #ada9a9;
          display: none;
        }

        &:hover {
          .clickOnCrop_box {
            display: inline-block;
          }
        }
      }

      .img-styles {
        width: 75px;
        height: 75px;
        object-fit: cover;
        border: 1px solid #ddd;
      }
    }

    .upload-box {
      width: 75px;
      height: 75px;
      color: #999999;
      transition: color 0.1s ease-in;
      background: #fff;
      border: 1px dashed #dcdee2;
      border-radius: 4px;
      text-align: center;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .upload-icon {
        font-size: 30px;
        display: block;
      }

      &:hover {
        color: #666666;
      }
    }

    .select_customized {
      position: absolute;
      bottom: 0;
      right: 0;
    }
  }
}
</style>